<template>
  <modal-wrap
    :id="id"
    ref="createSenderAddress"
    :name="modalName"
    :header-class="'service-level-header'"
    :body-class="'service-level-modal'"
    :dialog-class="'sender-modal'"
    :hide-footer="true"
    size="xl"
  >
    <template #modal-title> Add customer </template>
    <template #default>
      <div class="pt-3 mt-3">
        <CreateCustomerForm :created="customerCreated" @cancel="modalStore.closeModal(modalName)" />
      </div>
    </template>
  </modal-wrap>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { CREATE_NEW_CUSTOMER } from '@/const/ModalTypes'
import { useCustomersStore } from '@/store/customers'
import { useVueNextModalStore } from '@/store/vueNextModal'
import ModalWrap from '@/views/Modals/ModalWrap.vue'
import CreateCustomerForm from '@/views/Components/Customer/CreateCustomerForm.vue'

export default defineComponent({
  name: 'CreateNewCustomerModal',
  components: {
    CreateCustomerForm,
    ModalWrap,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  setup() {
    const modalStore = useVueNextModalStore()
    const customersStore = useCustomersStore()
    const modalName = CREATE_NEW_CUSTOMER

    const customerCreated = (): void => {
      modalStore.closeModal(modalName)
      customersStore.fetchAll()
    }

    return {
      modalName,
      modalStore,
      customerCreated,
    }
  },
})
</script>
